export const TABLE = {
    MIN_WIDTH: {
        SMALL_INT: 20, // Entier à 1 chiffre, peu de place nécessaire
        ID: 55,
        TEL: 110,
        EMAIL: 150,
        DATE: 90,
        DISCIPLINE: 90,
        EXAMEN: 120,
        NOTES: 450,
        SALLE: 90,
        PAIEMENT_MODE: 100,
        PAIEMENT_TYPE: 100,
        PAIEMENT_NUMERO: 50,
        PAIEMENT_MONTANT: 90,
        PAIEMENT_ETAB: 50,
        FACTURE_LIBELLE: 120,
        FACTURE_TAUX: 90,
        PARENTE: 80,
        NOM_PRENOM: 100,
        NOM_PRENOM_ID: 130,
        BORDEREAU: 50,
        JOUR: 76,
        CYCLE: 60,
        NIVEAU: 60,
        COURS: 150,
        ABSENCE_MOTIF: 100,
        ANNEE_SCOLAIRE: 70,
        NOTE: 70,
        NOTE_MENTION: 100,
        HORAIRE: 73,
        DUREE: 67,
        BOOLEAN: 20,
        LIBELLE_ACTION: 80,
        AN: 25,
    }
};



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/app.constantes.ts